import * as React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';

import { fetchArticles, env } from '../../../services/AppService';

const articleInfo = [
//  {
//    tag: 'Engineering',
//    title: 'The future of AI in software engineering',
//    description:
//      'Artificial intelligence is revolutionizing software engineering. Explore how AI-driven tools are enhancing development processes and improving software quality.',
//    authors: [
//      { name: 'Remy Sharp', avatar: '/static/images/avatar/1.jpg' },
//      { name: 'Travis Howard', avatar: '/static/images/avatar/2.jpg' },
//    ],
//  },
];

const StyledTypography = styled(Typography)({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const TitleTypography = styled(Typography)(({ theme }) => ({
  position: 'relative',
  textDecoration: 'none',
  '&:hover': { cursor: 'pointer' },
  '& .arrow': {
    visibility: 'hidden',
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  '&:hover .arrow': {
    visibility: 'visible',
    opacity: 0.7,
  },
  '&:focus-visible': {
    outline: '3px solid',
    outlineColor: 'hsla(210, 98%, 48%, 0.5)',
    outlineOffset: '3px',
    borderRadius: '8px',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    width: 0,
    height: '1px',
    bottom: 0,
    left: 0,
    backgroundColor: (theme.vars || theme).palette.text.primary,
    opacity: 0.3,
    transition: 'width 0.3s ease, opacity 0.3s ease',
  },
  '&:hover::before': {
    width: '100%',
  },
}));

function Author({ authors }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}
      >
        <AvatarGroup max={3}>
          {authors.map((author, index) => (
            <Avatar
              key={index}
              alt={author.name}
              src={author.avatar}
              sx={{ width: 24, height: 24 }}
            />
          ))}
        </AvatarGroup>
        <Typography variant="caption">
          {authors.map((author) => author.name).join(', ')}
        </Typography>
      </Box>
      <Typography variant="caption">July 14, 2021</Typography>
    </Box>
  );
}

Author.propTypes = {
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      avatar: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default function Latest() {
	const [focusedCardIndex, setFocusedCardIndex] = React.useState(null);

	const [articles, setArticles] = React.useState([]);
	const [currentPage, setCurrentPage] = React.useState(1);

	// xxx have a setting to change
	const postsPerPage = 5;
	
	const handleFocus = (index) => {
	  setFocusedCardIndex(index);
	};
	
	const handleBlur = () => {
	  setFocusedCardIndex(null);
	};

	React.useEffect(() => {
		fetchArticles()
			.then(response => {
				setArticles(response.data.results || response.data);	// Adjust based on API response.
			})
			.catch(error => console.error('Error fetching articles:', error));
	}, []);

	const totalPages = Math.ceil(articles.length / postsPerPage);
	const startIndex = (currentPage - 1) * postsPerPage;
	const MAX_INDEX = 10;
	const currentPosts = articles.slice(startIndex, startIndex + postsPerPage);

	const handlePageChange = (event, value) => {
		setCurrentPage(value);
	};

	const handleArticleClick = (slug) => {
		window.location.href = `article/${slug}`;
	};

	return (
<div>
<Typography variant="h2" gutterBottom>
Posts
</Typography>

<Grid container spacing={8} columns={1} sx={{ my: 4 }}>
{currentPosts.map(article => (
	<Grid key={article.id} size={{ xs: 12, sm: 6 }}>
	  <Box
	    sx={{
	      display: 'flex',
	      flexDirection: 'column',
	      justifyContent: 'space-between',
	      gap: 1,
	      height: '100%',
	    }}
	  >
	    <Typography gutterBottom variant="caption" component="div">
	      {article.tag}
	    </Typography>
	    <TitleTypography
	      gutterBottom
	      variant="h6"
	      onFocus={() => handleFocus(article.id)}
	      onBlur={handleBlur}
			onClick={() => handleArticleClick(article.slug)}
	      tabIndex={0}
	      className={focusedCardIndex === article.id ? 'Mui-focused' : ''}
	    >
	      {article.title}
	      <NavigateNextRoundedIcon
	        className="arrow"
	        sx={{ fontSize: '1rem' }}
	      />
	    </TitleTypography>
	    <StyledTypography variant="body2" color="text.secondary" gutterBottom>
	      {article.meta_description}
	    </StyledTypography>
	
	    {/*<Author authors={article.author} />*/}
	  </Box>
	</Grid>
    ))}
  </Grid>

	{/* Pagination */}
	<Box sx={{ display: 'flex', justifyContent: 'center', pt: 4}}>
		{totalPages > 1 && (
			<Pagination
				count={totalPages}
				page={currentPage}
				onChange={handlePageChange}
				color='parimy'
				variant='outlined'
				shape='rounded'
			/>
		)}
	</Box>

	{/* Old pagination:
  	<Box sx={{ display: 'flex', flexDirection: 'row', pt: 4 }}>
    	<Pagination hidePrevButton hideNextButton count={10} boundaryCount={10} />
  	</Box>
	*/}
</div>
  );
}
